export enum BonusomatQuestGameType {
    Casino = "Casino",
    LiveDealer = "LiveDealer",
}
